import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom'

import { Provider } from 'mobx-react';

import store from './store';
import shopStore from './stores/shopStore';
import MembershipApp from './apps/MembershipApp';
import ProductPurchaseApp from './apps/ProductPurchaseApp';
import DonationApp from './apps/DonationApp';
import Donation2App from './apps/Donation2App';
import DonationPrivateApp from './apps/DonationPrivateApp';
import KabbalahoneApp from './apps/KabbalahoneApp';
import PurchaseProductsApp from './apps/PurchaseProductsApp';
import StreamPpvApp from './apps/StreamPpvApp';
import DonationTicketApp from './apps/DonationTicketApp';
import ConfirmationView from './views/ConfirmationView';
import TicketsView from './views/TicketsView';
import PortalView from './views/PortalView';
import ErrorView from './views/ErrorView';
import WithLogin from './views/WithLoginWrapperView';
import CourseView from './views/CourseView';
import './css/main.css';

class App extends Component {

  	render() {
		const { customer, purchaseUrl, tickets } = this.props.data;
		if (tickets) {
			// RENDER TICKET WIDGET
			store.initCustomer(customer);
			store.purchaseUrl = purchaseUrl;
			store.initTickets(tickets);    
			return (
				<Provider store={store}>
					<Router>
						<span className="tkc-widget-container">
							<Route exact path="/" component={TicketsView} />
							<Route path="/confirmation" component={ConfirmationView} />
							<Route path="/error" component={ErrorView} />
						</span>
					</Router>
				</Provider>
			);			
		}

		const context = window.tkcWidgetContext;
		if (context.action === 'membership') {					
			return <MembershipApp />;
		}						
		if (context.action === 'donate') {
			// RENDER DONATION WIDGET			
			return <DonationApp />
		}
		if (context.action === 'donate2') {
			// RENDER DONATION WIDGET			
			return <Donation2App />
		}			
		if (context.action === 'donatePrivate') {			
			return <DonationPrivateApp />
		}			
		if (context.action === 'streamPpv') {			
			return <StreamPpvApp />
		}	
		if (context.action === 'donationTicket') {			
			return <DonationTicketApp />
		}					
		if (context.action === 'purchaseProducts') {						
			return <PurchaseProductsApp />
		}			
		if (context.action === 'purchaseProduct') {
			// RENDER PRODUCT PURCHASE WIDGET
			return <ProductPurchaseApp />
		}			
		if (context.action === 'kabbalahone') {
			// RENDER KABBALAHONE WIDGET			
			return <KabbalahoneApp />
		}			
		// RENDER WEBCAST APP (TODO Need to specify action)
		store.netsuiteBaseUrl = context.netsuiteBaseUrl;
		store.salesforceBaseUrl = context.salesforceBaseUrl;
		if (context.sessionToken) {
			sessionStorage.setItem('sessionToken', context.sessionToken);  
			store.hasSessionToken.set(true);   
		}    	
		return (
			<Provider store={store} shopStore={shopStore}>          
				<Router>
					<span className="tkc-widget-container">                              
						<WithLogin>          
							<Route exact path="/" component={PortalView} /> 
							<Route exact path="/courses/:courseId" component={CourseView} />						
						</WithLogin>               
					</span>
				</Router>          
			</Provider>
		);
		
  	}

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js